import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import {
  allowedProfileImageTypes,
  errorType,
  photoTooLarge,
  photoTypeNotAllowed,
  maxAttachmentSizeBytes,
  photoLoadFailed,
  snackBarConfig
} from '../../../app.constants';

@Component({
  selector: 'aum-cli-edit-image',
  templateUrl: './edit-image.component.html',
  styleUrls: ['./edit-image.component.scss']
})
export class EditImageComponent implements OnInit, AfterContentChecked {
  @ViewChild('fileInput', { static: true }) fileInput: ElementRef;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  canvasRotation = 0;
  scale = 1;
  showCropper = false;
  transform: ImageTransform = {};

  constructor(
    private cdref: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private dialogRef: MatDialogRef<EditImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Event
  ) {}

  ngOnInit(): void {
    this.imageChangedEvent = this.data;
  }
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  close() {
    this.dialogRef.close();
  }

  fileChangeEvent(event: any): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;

    if (!allowedProfileImageTypes.includes(file.type)) {
      this.snackBar.open(
        this.translateService.instant(photoTypeNotAllowed, { fileName: file.name }),
        this.translateService.instant(errorType),
        snackBarConfig
      );
      (event.target as HTMLInputElement).value = '';
      return;
    }

    if (file.size > maxAttachmentSizeBytes) {
      this.snackBar.open(
        this.translateService.instant(photoTooLarge, { fileName: file.name }),
        this.translateService.instant(errorType),
        snackBarConfig
      );
      (event.target as HTMLInputElement).value = '';
      return;
    }

    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  imageLoaded() {
    this.showCropper = true;
  }

  loadImageFailed() {
    this.snackBar.open(
      this.translateService.instant(photoLoadFailed),
      this.translateService.instant(errorType),
      snackBarConfig
    );
  }

  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  rotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV
    };
  }

  choosePhoto() {
    this.fileInput.nativeElement.click();
  }
}
